import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { IMappingFiltersState } from './mappingFilters.interface';
import { IQuestionFilterItem } from '@redux/Studio/QueryCreation/constants/queryCreation.interface';

export const updateMappingFiltersReduxSlice = {
  resetState: (state: IMappingFiltersState) => {
    state.showFiltersModal = initialState.showFiltersModal;
    state.copiedMappingFilters = initialState.copiedMappingFilters;
    state.copiedFilterPropType = initialState.copiedFilterPropType;
  },

  openFilters: (state: IMappingFiltersState) => {
    state.showFiltersModal = true;
  },

  closeFilters: (state: IMappingFiltersState) => {
    state.showFiltersModal = false;
  },

  copyQueryMappingFilter: (
    state: IMappingFiltersState,
    action: PayloadAction<{
      copiedMappingFilters: IQuestionFilterItem[];
      copiedFilterPropType: string;
    }>
  ) => {
    state.copiedMappingFilters = action.payload.copiedMappingFilters;
    state.copiedFilterPropType = action.payload.copiedFilterPropType;
  },

  resetCopiedQueryMappingFilter: (state: IMappingFiltersState) => {
    state.copiedMappingFilters = initialState.copiedMappingFilters;
    state.copiedFilterPropType = initialState.copiedFilterPropType;
  },
};

const MappingFiltersReduxSlice = createSlice({
  name: 'mappingFilters',
  initialState: initialState,
  reducers: { ...updateMappingFiltersReduxSlice },
});

export const {
  resetState,
  openFilters,
  closeFilters,
  copyQueryMappingFilter,
  resetCopiedQueryMappingFilter,
} = MappingFiltersReduxSlice.actions;

export default MappingFiltersReduxSlice.reducer;
